/**
 * When the Breast Cancer Awareness ribbon is drawn on the logo: October 2026, in the viewer's own
 * time zone. The end is exclusive, so the plain logo returns at midnight on November 1 without a
 * release. A tab left open across that midnight keeps the ribbon until it reloads.
 *
 * This is a date and not a Flagsmith flag on purpose: a flag that does not exist in Flagsmith reads
 * as off, so the campaign would depend on someone creating and enabling it. To end the campaign
 * early, ship a change that moves the end date back.
 */
export const AWARENESS_RIBBON_START = new Date(2026, 9, 1);

export const AWARENESS_RIBBON_END = new Date(2026, 10, 1);

export function isAwarenessRibbonActive(now: Date = new Date()): boolean {
  return now >= AWARENESS_RIBBON_START && now < AWARENESS_RIBBON_END;
}
